import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.map.js";
import { defineComponent as _defineComponent } from 'vue';
import { useDelActivityStakeholderLinkMutation, useListActivityStakeholderLinksQuery, useUpdateActivityStakeholderLinkMutation } from '~/types/types';
export default /*#__PURE__*/_defineComponent({
  __name: 'ActivityStakeholderLink',
  setup: function setup(__props) {
    var attrs = useAttrs();
    var headerConfig = {
      id: {
        sortable: true
      },
      'stakeholder.name': {},
      'stakeholder.type': {},
      impactMaterial: {},
      financialMaterial: {},
      actions: {
        text: ''
      }
    };
    var headers = computed(function () {
      return attrs === null || attrs === void 0 ? void 0 : attrs.headers.map(function (h) {
        return _objectSpread(_objectSpread({
          value: h.value || h
        }, headerConfig[h.value || h]), h);
      });
    });
    var options = ref({
      page: 1,
      itemsPerPage: 10,
      sortDesc: [true]
    });
    var search = ref('');
    var variables = computed(function () {
      return {
        activityId: attrs['activity-id'],
        offset: options.value.itemsPerPage * (options.value.page - 1),
        limit: options.value.itemsPerPage
      };
    });
    var _useListActivityStake = useListActivityStakeholderLinksQuery(variables, computed(function () {
        return {
          enabled: !!variables.value.activityId
        };
      })),
      result = _useListActivityStake.result,
      refetch = _useListActivityStake.refetch,
      loading = _useListActivityStake.loading;
    var _useDelActivityStakeh = useDelActivityStakeholderLinkMutation(),
      delActivityStakeholderLink = _useDelActivityStakeh.mutate;
    var items = computed(function () {
      var _result$value$listAct, _result$value;
      return (_result$value$listAct = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.listActivityStakeholderLinks) !== null && _result$value$listAct !== void 0 ? _result$value$listAct : [];
    });
    var itemCount = computed(function () {
      var _result$value2;
      return (result === null || result === void 0 ? void 0 : (_result$value2 = result.value) === null || _result$value2 === void 0 ? void 0 : _result$value2.countActivityStakeholderLinks) || 0;
    });
    var _useUpdateActivitySta = useUpdateActivityStakeholderLinkMutation(),
      updateActivityStakeholderLink = _useUpdateActivitySta.mutate,
      onDone = _useUpdateActivitySta.onDone;
    onDone(function () {
      window.$nuxt.$emit('userMsg');
    });
    return {
      __sfc: true,
      attrs: attrs,
      headerConfig: headerConfig,
      headers: headers,
      options: options,
      search: search,
      variables: variables,
      result: result,
      refetch: refetch,
      loading: loading,
      delActivityStakeholderLink: delActivityStakeholderLink,
      items: items,
      itemCount: itemCount,
      updateActivityStakeholderLink: updateActivityStakeholderLink,
      onDone: onDone
    };
  }
});